import { put, takeLatest, call } from 'redux-saga/effects';
import { OK } from 'http-status-codes';
import { safeResolveAsync } from '../../utils/saga';
import * as api from './api';
import { types, actions } from './duck';


// --- GET PAYMENT METHODS
function* getPaymentMethodsSaga() {
  try {
    yield put(actions.getPaymentMethodsRequest());
    const response = yield call(api.getPaymentMethodsApi);

    if (response.status === OK) {
      // DRF returns the list directly, so we pass response.data
      yield put(actions.getPaymentMethodsSuccess(response.data));
    } else {
      yield put(actions.getPaymentMethodsFailure('Failed to load payment methods'));
    }
  } catch (err) {
    yield put(actions.getPaymentMethodsFailure(err.message));
  }
}


// --- SUBSCRIPTION
function* subscribeSaga({ payload, resolve }) {
  try {
    yield put(actions.subscribeRequest());
    const response = yield call(api.subscribeApi, payload);
    // console.log("response", response);

    if (response.status === OK && response.data.success) {
      yield put(actions.subscribeSuccess(response.data));
      yield safeResolveAsync(resolve, response.data);
    } else {
      const errors = (response.data && response.data.error) || response.statusText || 'Unknown error';
      yield put(actions.subscribeFailure(errors));
      yield safeResolveAsync(resolve, { success: false, error: errors });
    }
  } catch (err) {
    console.log("err", err);

    // // yield put(actions.subscribeFailure(err.message));
    // yield put(actions.subscribeFailure(err.message));
    // yield safeResolveAsync(resolve, { success: false, error: "Internal server error. Please try again." });
    const errorMessage = (err.response && err.response.data && err.response.data.error) || "Internal server error. Please try again.";
    yield put(actions.subscribeFailure(errorMessage));
    yield safeResolveAsync(resolve, { success: false, error: errorMessage });
  }
}

// --- CHECKOUT
function* checkoutSaga({ payload, resolve }) {
  try {
    yield put(actions.checkoutRequest());
    const response = yield call(api.checkoutApi, payload);
    // console.log("response", response);

    if (response.status === OK && response.data.success) {
      yield put(actions.checkoutSuccess(response.data));
      yield safeResolveAsync(resolve, response.data);
    } else {
      const errors = (response.data && response.data.error) || response.statusText || 'Unknown error';
      yield put(actions.checkoutFailure(errors));
      yield safeResolveAsync(resolve, { success: false, error: errors });
    }
  } catch (err) {
    // yield put(actions.checkoutFailure(err.message));
    // yield safeResolveAsync(resolve, { success: false, error: "Internal server error. Please try again." });
    const errorMessage = (err.response && err.response.data && err.response.data.error) || "Internal server error. Please try again.";
    yield put(actions.subscribeFailure(errorMessage));
    yield safeResolveAsync(resolve, { success: false, error: errorMessage });
  }
}

// --- VALIDATE PROMO CODE
function* validatePromoCodeSaga({ payload, resolve }) {
  try {
    yield put(actions.validatePromoCodeRequest());
    const response = yield call(api.validatePromoCodeApi, payload); // e.g. { code: 'SAVE20' }

    if (response.status === OK) {
      yield put(actions.validatePromoCodeSuccess(response.data));
      yield safeResolveAsync(resolve, response.data);
    } else {
      const errors = (response.data && response.data.error) || response.statusText || 'Invalid promo code';
      yield put(actions.validatePromoCodeFailure(errors));
      yield safeResolveAsync(resolve, { success: false, error: errors });
    }
  } catch (err) {
    const errorMessage = (err.response && err.response.data && err.response.data.error) || "Internal server error. Please try again.";
    yield put(actions.validatePromoCodeFailure(errorMessage));
    yield safeResolveAsync(resolve, { success: false, error: errorMessage });
  }
}

// --- ROOT SAGA
export default function* paymentSaga() {
  yield takeLatest(types.GET_PAYMENT_METHODS, getPaymentMethodsSaga);
  yield takeLatest(types.SUBSCRIBE, subscribeSaga);
  yield takeLatest(types.CHECKOUT, checkoutSaga);
  yield takeLatest(types.VALIDATE_PROMO_CODE, validatePromoCodeSaga);
}
